import { reactive, toRefs } from 'vue';
import { Form as AForm } from 'ant-design-vue/es';
import 'ant-design-vue/es/form/style/css';
import "core-js/modules/es.array.push.js";
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { setEncrypt, getDecrypt } from '@/utils/rsa';
export default {
  name: 'Index',
  components: {},
  props: {},
  setup() {
    const store = useStore();
    const router = useRouter();
    const LoginState = reactive({
      loginBtn: false,
      isLoginError: false,
      accountLoginErrMsg: '',
      logininfo: {
        tenantId: 0,
        account: '',
        password: ''
      },
      rulesRef: {
        username: [{
          required: true,
          message: '请输入账号'
        }]
      }
    });
    const {
      resetFields,
      validate,
      validateInfos
    } = AForm.useForm(LoginState.logininfo, LoginState.rulesRef, {
      onValidate: (...args) => {
        console.log(...args);
      }
    });
    const onSubmit = () => {
      LoginState.loginBtn = true;
      validate().then(() => {
        LoginState.isLoginError = false;
        LoginState.logininfo.password = setEncrypt(LoginState.logininfo.password);
        var user = {
          UserName: LoginState.logininfo.account,
          Password: LoginState.logininfo.password
        };
        store.dispatch("Login", user).then(res => {
          console.log(res);
          /* store.dispatch("DictTypeData").then((res) => {
          	console.log(res)
          }) */

          router.push('/');
        }).catch(err => {
          console.log(err);
          LoginState.accountLoginErrMsg = err;
          LoginState.isLoginError = true;
        }).finally(() => {
          LoginState.loginBtn = false;
        });
        // 加载字典所有字典到缓存中
        //this.dictTypeData().then((res) => { })
      });
    };

    return {
      ...toRefs(LoginState),
      validateInfos,
      resetFields,
      onSubmit
    };
  },
  created() {},
  mounted() {},
  methods: {}
};